module.exports = __webpack_public_path__ + "static/media/london-fashion-week.c23926bf.png";